import dayjs from "dayjs";

/**
 * The grid filter interfaces may have properties defined as Date, but because of NGRX and other stuff, this will often actually be a string.
 * I do not want to define the parameter as "Date | string" because I want the type-checking to ensure this is only called on properties where a date
 * is expected.  The auto-generated code will call toISOString, but we do not want the time zone; hence why we are replacing its implementation.
 */

export function gridDate(date: Date): Date | null | undefined {
    if (date == null) {
        return date;
    }

    const dayjsDate = dayjs(date);
    if (!dayjsDate.isValid()) {
        return null;
    }

    const result = dayjsDate.toDate();
    result.toISOString = function () { return dayjs(this).format('YYYY-MM-DD'); }
    return result;
}
